import React from 'react';
import { Panel, Label } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import { mapStatusToLabel } from '../paymentHistory/utils';

const UsageList = ({ isReadonly, discount, t, ...rest }) => {
	const categoryPath = (paymentCategory) => {
		switch (paymentCategory) {
			case 'Lesson': return 'paymentHistory';
			case 'Workshop': return 'workshopPayments';
			case 'Consultation': return 'individualConsultations';
		}
	}
	const columns = [
		{
			header: t('PaymentHistory_Id'),
			accessor: 'paymentId',
			sortable: true,
			cell: (paymentId, row)  => <Link to={`/${categoryPath(row.paymentCategory)}/${paymentId}`}>{paymentId}</Link>
		},
		{
			header: t('PaymentHistory_Status'),
			accessor: 'status',
			sortKey: 'status',
			sortable: true,
			cell: status => <Label bsStyle={mapStatusToLabel(status.id)}>{t(`PaymentStatusType_${status.name}`)}</Label>
		},
		{
			header: t('PaymentHistory_Parent'),
			accessor: 'parent.name',
			sortable: true,
			sortKey: 'parent'
		},
		{
			header: t('PaymentHistory_Child'),
			accessor: 'child.name',
			sortable: true,
			sortKey: 'child'
		}
	];
	
	if (discount.typeId === 5 && discount.allowPartialUse) {
		columns.push({
			header: t('Discount_UsedAmount'),
			accessor: 'usedAmount',
			sortable: true,
			cell: usedAmount => usedAmount 
		});
	}

	return <PagedEntitiesList columns={columns} {...rest} />;
};

export default withTranslation()(UsageList);